module.exports = __webpack_public_path__ + "static/video-bg-ef61536dc41955c3c6148b8272991b4e.svg";